import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 20 20',
    defaultAriaLabel: 'Cross Icon',
};

export const CrossIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props} fill="currentColor">
            <path d="M15.9422 4.96681C16.1932 4.71576 16.1932 4.30872 15.9422 4.05767C15.6911 3.80662 15.2841 3.80662 15.033 4.05767L9.98866 9.10205L4.96754 4.08093C4.71649 3.82988 4.30946 3.82988 4.05841 4.08093C3.80735 4.33198 3.80735 4.73902 4.05841 4.99007L9.07952 10.0112L4.08071 15.01C3.82966 15.2611 3.82966 15.6681 4.08071 15.9191C4.33176 16.1702 4.73879 16.1702 4.98985 15.9191L9.98866 10.9203L15.0107 15.9424C15.2618 16.1935 15.6688 16.1935 15.9199 15.9424C16.1709 15.6913 16.1709 15.2843 15.9199 15.0333L10.8978 10.0112L15.9422 4.96681Z" />
        </SvgIcon>
    );
};
